import { useMutation } from '@tanstack/react-query';
import { shareListSort } from '../../../api/ListSort/shareListSort';

export function useShareListSort() {
  const shareListSortMutationFunction = async ({ id, emails, share_decision_data, share_pictures, share_notes }) => {
    const requestBody = {
      emails: emails,
      share_decision_data: share_decision_data,
      share_pictures: share_pictures,
      share_notes: share_notes
    };
    return await shareListSort({ id: id, requestBody: requestBody });
  };

  const shareListSortMutation = useMutation({
    mutationFn: (body: { id: string, emails: string[], share_decision_data: boolean, share_pictures: boolean, share_notes: boolean }) => shareListSortMutationFunction(body)
  });

  return {
    shareListSort: shareListSortMutation.mutateAsync,
    isSuccess: shareListSortMutation.isSuccess,
    isError: shareListSortMutation.isError,
    isPending: shareListSortMutation.isPending,
    error: shareListSortMutation.error,
    response: shareListSortMutation.data,
  };
}
